<script lang="ts">
    import {onMount} from "svelte";
    import {afterUpdate} from 'svelte';
    import lang from "../lang/language";

    import wishlist from '../store/wishlist';
    import type {ServiceType} from '../store/types';

    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import Button from "./controls/Button.svelte";

    export let service: ServiceType;

    let wishlistIds = wishlist.ids;
    const like = (e) => {
        e.stopPropagation();
        wishlist.add(service);
    }

    $: liked = $wishlistIds.includes(service.Id);

    let tippyInstance = [];

    afterUpdate(() => {

        tippyInstance.forEach(item => item.destroy());

        tippyInstance = tippy('.like-button.liked', {
            content: lang.remove_from_wishlist,
            placement: 'left',
        });

        tippyInstance = [...tippy('.like-button:not(.liked)', {
            content: lang.add_to_wishlist,
            placement: 'left',
        }), ...tippyInstance];

    });

</script>

<Button primary
        onClick={like}>
    {liked ? lang.remove_from_wishlist : lang.add_to_wishlist}
</Button>

<style>
    :global(.like-button) {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        color: rgba(255, 255, 255, 0.74);
        cursor: pointer;
        text-align: center;
        padding: 9px 0px;
        font-size: 20px;
        background-color: rgba(0, 0, 0, 0.50);
        border: 1px solid rgba(0, 0, 0, 0.50);
        transition: all .4s;
        font-family: 'Myriad Pro Regular';
    }

    :global(.like-button:active) {
        padding: 5px 0px;
    }

    :global(.like-button:hover) {
        background-color: black;
        color: white;
        border: 1px solid #454444;
        transition: all .4s;
    }

    :global(.like-button:active) > :global(i) {
        font-size: 30px;
        transition: all .3s;
    }

    :global(.like-button.liked) {
        color: #dd646a;
        /*text-shadow: 1px 1px #0e0000;*/
    }
</style>